import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  getCardElementFrameContainerStyle,
  getCardElementFrameStyle,
} from './helpers';
import useComponentBounds from '../../../../hooks/useComponentBounds';

const propTypes = {
  className: PropTypes.string,
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object,
    side: PropTypes.string,
  }),
  children: PropTypes.node,
  cardSideSize: PropTypes.shape({
    width: PropTypes.number,
  }),
  teamPhotos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      photo: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  ),
};

const CardElementFrame = ({ className, element, children, teamPhotos }) => {
  const classes = classNames({
    [className]: !!className,
    'card-element-frame': true,
    [`card-element-frame-${element.cardElement.type.toLowerCase()}`]: true,
    'card-element-frame-has-configuration':
      Object.keys(element.cardElementConfiguration ?? {})?.length > 0,
    'is-not-printable':
      element.cardElementConfiguration?.is_printable === false,
  });

  const ref = useRef();
  const { bounds } = useComponentBounds(ref);

  return (
    <div
      ref={ref}
      className={classes}
      style={getCardElementFrameStyle(element, teamPhotos)}
    >
      <div
        className="card-element-frame-container"
        style={getCardElementFrameContainerStyle(element, bounds)}
      >
        {children}
      </div>
    </div>
  );
};

CardElementFrame.propTypes = propTypes;

export default CardElementFrame;
